module.exports = __webpack_public_path__ + "img/audio.9c7be9ee.png";